import request from '@/utils/request'

const getCurrent = () => {
  return request({
    url: `/api/ranking/current`,
    method: 'get'
  })
}

const claim = milestoneOrder => {
  return request({
    url: `/api/ranking/claim`,
    method: 'post',
    data: { milestoneOrder }
  })
}

export default {
  getCurrent,
  claim
}
